export default __webpack_public_path__ + "static/media/Check.8e19020f.svg";